<div class="elastic-global-search-wrapper topSearch" appClickOutside (clickOutside)="clickOutside($event)">
    <div class="elastic-search-body" #elasticSearchBody>

        <span class="p-input-icon-right">
            <i *ngIf="searchControl.value?.length>0" (click)="clearSearch()" class="pi pi-times"></i>
            <input
                #SearchInput
                class="elastic-search-input"
                (click)="onSearchInputClick()"
                (keydown.ArrowUp)="onArrowUp($event)"
                (keydown.ArrowDown)="onArrowDown($event)"
                (keydown.enter)="searchEnterPress()"
                type="text"
                (input)="showSearchSuggestions=true;"
                pInputText
                placeholder="Search across modules or type @ to search in a specific module"
                [formControl]="searchControl" />
        </span>

        <div *ngIf="showSearchSuggestions" class="elastic-search-suggestions">
            <div class="p-card">
                <p-tabView *ngIf="searchResults.length > 0 && !loadingSearchResults" styleClass="elastic-search-tab" [(activeIndex)]="selectedTabIndex" (onChange)="changeTab($event)">
                    <p-tabPanel *ngFor="let tabDetails of searchResults" [header]="tabDetails.tabName">
                        <ul class="elastic-search-list">
                            <div *ngIf="spinnerOnTabChange" class="p-d-flex p-ai-center p-jc-center" [style]="{height: '50px', 'margin-top': '5rem'}">
                                <p-progressSpinner [style]="{width: '25px', height: '25px'}" styleClass="custom-spinner" animationDuration=".5s"></p-progressSpinner>
                            </div>
                            <li *ngFor="let searchDetails of tabDetails.searchResults" (click)="searchDetailsPopup.toggle($event)" >
                                <div class="elastic-search-block">
                                    <div [style]="{width: '100%'}">
                                        <div class="elastic-search-title">
                                            <div [innerHTML]="searchDetails?.title"></div>
                                        </div>
                                        <p [innerHTML]="searchDetails?.subTitle"></p>
                                    </div>
                                    <a *ngIf="!navigationHiddens.includes(tabDetails.modulePath)" class="p-mr-0 p-ml-2">
                                        <i class="fa fa-external-link" (click)="navigateToDetailsPage(tabDetails, searchDetails)"></i>
                                    </a>
                                </div>

                                <p-overlayPanel [appendTo]="elasticSearchBody" styleClass="elastic-search-popup" #searchDetailsPopup my="right top" [dismissable]="true" [showCloseIcon]="true">
                                    <div [style]="{minHeight: '100px', minWidth: '100px'}" #actualTarget>
                                        <ng-container *ngTemplateOutlet="detailsPopupTemplate;context:{tabDetails: tabDetails, searchDetails: searchDetails.contentDetails}"></ng-container>
                                    </div>
                                </p-overlayPanel>
                            </li>
                        </ul>
                    </p-tabPanel>
                </p-tabView>

                <ng-template #detailsPopupTemplate let-tabDetails="tabDetails" let-item="searchDetails">
                    <ng-container [ngSwitch]="tabDetails.modulePath">
                        <!-- Switch Start -->

                        <ng-container *ngSwitchCase="globalSearchPath.Account">
                            <div class="global-search-popup">
                                <div class="global-search-popup-title" [innerHTML]="item?.businessname"></div>
                                <ul class="global-search-popup-list">
                                    <ng-container *ngFor="let rule of accountDisplayRules">
                                        <li *ngIf="item[rule?.fieldName]">
                                            <ng-container>
                                                <span>{{rule?.name}}</span>
                                                <span [innerHTML]="item[rule?.fieldName]"></span>
                                            </ng-container>

                                        </li>
                                    </ng-container>

                                </ul>
                            </div>
                        </ng-container>

                        <ng-container *ngSwitchCase="globalSearchPath.Contact">
                            <div class="global-search-popup">
                                <div class="global-search-popup-title" [innerHTML]="item?.contactname"></div>
                                <ul class="global-search-popup-list">
                                    <ng-container *ngFor="let rule of contactDisplayRules">
                                        <li *ngIf="item[rule?.fieldName]">
                                            <ng-container>
                                                <span>{{rule?.name}}</span>
                                                <span [innerHTML]="item[rule?.fieldName]"></span>
                                            </ng-container>

                                        </li>
                                    </ng-container>
                                </ul>
                            </div>
                        </ng-container>

                        <ng-container *ngSwitchCase="globalSearchPath.Lead">
                            <div class="global-search-popup">
                                <div class="global-search-popup-title" [innerHTML]="item?.businessname"></div>
                                <ul class="global-search-popup-list">
                                    <ng-container *ngFor="let rule of leadDisplayRules">
                                        <li *ngIf="item[rule?.fieldName]">
                                            <ng-container>
                                                <span>{{rule?.name}}</span>
                                                <span [innerHTML]="item[rule?.fieldName]"></span>
                                            </ng-container>

                                        </li>
                                    </ng-container>
                                </ul>
                            </div>
                        </ng-container>

                        <ng-container *ngSwitchCase="globalSearchPath.Opportunity">
                            <div class="global-search-popup">
                                <div class="global-search-popup-title" [innerHTML]="item?.name"></div>
                                <ul class="global-search-popup-list">
                                    <ng-container *ngFor="let rule of opportunityDisplayRules">
                                        <li *ngIf="item[rule?.fieldName]">
                                            <ng-container>
                                                <span>{{rule?.name}}</span>
                                                <span [innerHTML]="item[rule?.fieldName]"></span>
                                            </ng-container>

                                        </li>
                                    </ng-container>
                                </ul>
                            </div>
                        </ng-container>

                        <ng-container *ngSwitchCase="globalSearchPath.Product">
                            <div class="global-search-popup">
                                <div class="global-search-popup-title" [innerHTML]="(item?.name||item?.itemno)"></div>
                                <ul class="global-search-popup-list">
                                    <ng-container *ngFor="let rule of productDisplayRules">
                                        <li *ngIf="item[rule?.fieldName]">
                                            <ng-container>
                                                <span>{{rule?.name}}</span>
                                                <span [innerHTML]="item[rule?.fieldName]"></span>
                                            </ng-container>

                                        </li>
                                    </ng-container>
                                </ul>
                            </div>
                        </ng-container>


                        <ng-container *ngSwitchCase="globalSearchPath.Purchases">
                            <div class="global-search-popup">
                                <div class="global-search-popup-title" [innerHTML]="(item?.name||item?.ponumber)"></div>
                                <ul class="global-search-popup-list">
                                    <ng-container *ngFor="let rule of  purchaseDisplayRules">
                                        <li *ngIf="item[rule?.fieldName]">
                                            <ng-container>
                                                <span>{{rule?.name}}</span>
                                                <span [innerHTML]="item[rule?.fieldName]"></span>
                                            </ng-container>

                                        </li>
                                    </ng-container>
                                </ul>
                            </div>
                        </ng-container>

                        <ng-container *ngSwitchCase="globalSearchPath.SalesOrder">
                            <div class="global-search-popup">
                                <div class="global-search-popup-title" [innerHTML]="(item?.name||item?.sonumber)"></div>
                                <ul class="global-search-popup-list">
                                    <ng-container *ngFor="let rule of  salesOrderDisplayRules">
                                        <li *ngIf="item[rule?.fieldName]">
                                            <ng-container>
                                                <span>{{rule?.name}}</span>
                                                <span [innerHTML]="item[rule?.fieldName]"></span>
                                            </ng-container>

                                        </li>
                                    </ng-container>
                                </ul>
                            </div>
                        </ng-container>

                        <ng-container *ngSwitchCase="globalSearchPath.Estimate">
                            <div class="global-search-popup">
                                <div class="global-search-popup-title" [innerHTML]="(item?.name||item?.estimatenumber)"></div>
                                <ul class="global-search-popup-list">
                                    <ng-container *ngFor="let rule of estimateDisplayRules">
                                        <li *ngIf="item[rule?.fieldName]">
                                            <ng-container>
                                                <span>{{rule?.name}}</span>
                                                <span [innerHTML]="item[rule?.fieldName]"></span>
                                            </ng-container>

                                        </li>
                                    </ng-container>
                                </ul>
                            </div>
                        </ng-container>

                        <ng-container *ngSwitchCase="globalSearchPath.Invoice">
                            <div class="global-search-popup">
                                <div class="global-search-popup-title" [innerHTML]="(item?.name||item?.invoicenumber)"></div>
                                <ul class="global-search-popup-list">
                                    <ng-container *ngFor="let rule of invoiceDisplayRules">
                                        <li *ngIf="item[rule?.fieldName]">
                                            <ng-container>
                                                <span>{{rule?.name}}</span>
                                                <span [innerHTML]="item[rule?.fieldName]"></span>
                                            </ng-container>

                                        </li>
                                    </ng-container>
                                </ul>
                            </div>
                        </ng-container>

                        <ng-container *ngSwitchCase="globalSearchPath.BillOrder">
                            <div class="global-search-popup">
                                <div class="global-search-popup-title" [innerHTML]="(item?.name||item?.billnumber)"></div>
                                <ul class="global-search-popup-list">
                                    <ng-container *ngFor="let rule of billOrderDisplayRules">
                                        <li *ngIf="item[rule?.fieldName]">
                                            <ng-container>
                                                <span>{{rule?.name}}</span>
                                                <span [innerHTML]="item[rule?.fieldName]"></span>
                                            </ng-container>

                                        </li>
                                    </ng-container>
                                </ul>
                            </div>
                        </ng-container>


                        <ng-container *ngSwitchCase="globalSearchPath.Territory">
                            <div class="global-search-popup">
                                <div class="global-search-popup-title" [innerHTML]="(item?.name||item?.territoryname)"></div>
                                <ul class="global-search-popup-list">
                                    <ng-container *ngFor="let rule of territoryDisplayRules">
                                        <li *ngIf="item[rule?.fieldName]">
                                            <ng-container>
                                                <span>{{rule?.name}}</span>
                                                <span [innerHTML]="item[rule?.fieldName]"></span>
                                            </ng-container>

                                        </li>
                                    </ng-container>
                                </ul>
                            </div>
                        </ng-container>

                        <ng-container *ngSwitchCase="globalSearchPath.Case">
                            <div class="global-search-popup">
                                <div class="global-search-popup-title" [innerHTML]="item?.caseno"></div>
                                <ul class="global-search-popup-list">
                                    <ng-container *ngFor="let rule of casesDisplayRules">
                                        <li *ngIf="item[rule?.fieldName]">
                                            <ng-container>
                                                <span>{{rule?.name}}</span>
                                                <span [innerHTML]="item[rule?.fieldName]"></span>
                                            </ng-container>

                                        </li>
                                    </ng-container>
                                </ul>
                            </div>
                        </ng-container>

                        <ng-container *ngSwitchCase="globalSearchPath.SerialNo">
                            <div class="global-search-popup">
                                <p-tabView *ngIf="item?.serialNoDetails?.length > 0" styleClass="elastic-search-tab">
                                    <p-tabPanel *ngFor="let serialDetails of item?.serialNoDetails" [header]="serialDetails.tabHeader">
                                        <div class="global-search-popup-title">{{ serialDetails.tabHeader }} Details

                                            <a *ngIf="!navigationHiddens.includes(serialDetails.modulePath)" class="p-mr-0 p-ml-2">
                                                <i class="fa fa-external-link" (click)="navigateToDetailsPage(serialDetails, serialDetails.details)"></i>
                                            </a>
                                        </div>

                                        <ul class="global-search-popup-list">
                                            <ng-container *ngFor="let rule of serialNoDisplayRules">
                                                <li *ngIf="serialDetails.details.contentDetails[rule?.fieldName] && rule?.sectionId==serialDetails.details.contentDetails?.sectionid">
                                                    <ng-container>
                                                        <span>{{rule?.name}}</span>
                                                        <span [innerHTML]="serialDetails.details.contentDetails[rule?.fieldName]"></span>
                                                    </ng-container>
                                                </li>
                                            </ng-container>
                                        </ul>
                                    </p-tabPanel>
                                </p-tabView>
                            </div>
                        </ng-container>

                        <ng-container *ngSwitchCase="globalSearchPath.CustomerRma">
                            <div class="global-search-popup">
                                <div class="global-search-popup-title" [innerHTML]="(item?.name)"></div>
                                <ul class="global-search-popup-list">
                                    <ng-container *ngFor="let rule of customerRMADisplayRules">
                                        <li *ngIf="item[rule?.fieldName]">
                                            <ng-container *ngIf="rule?.name == 'Invoice Number'">
                                                <span>{{rule?.name}}</span>
                                                <a style="cursor: pointer;" (click)="inVoiceNavigation(item?.invoicedetails,item)">
                                                    <span [innerHTML]="item[rule?.fieldName]"></span>
                                                </a>
                                            </ng-container>
                                            <ng-container *ngIf="rule?.name != 'Invoice Number'">
                                                <span>{{rule?.name}}</span>
                                                <span [innerHTML]="item[rule?.fieldName]"></span>
                                            </ng-container>
                        
                                        </li>
                                    </ng-container>
                                </ul>
                            </div>
                        </ng-container>

                        <ng-container *ngSwitchCase="globalSearchPath.CreditMemo">
                            <div class="global-search-popup">
                                <div class="global-search-popup-title" [innerHTML]="(item?.name)"></div>
                                <ul class="global-search-popup-list">
                                    <ng-container *ngFor="let rule of creditMemoDisplayRules">
                                        <li *ngIf="item[rule?.fieldName]">
                                            <ng-container>
                                                <span>{{rule?.name}}</span>
                                                <span [innerHTML]="item[rule?.fieldName]"></span>
                                            </ng-container>
                        
                                        </li>
                                    </ng-container>
                                </ul>
                            </div>
                        </ng-container>
                        <!-- Switch End -->
                    </ng-container>
                </ng-template>

                <div *ngIf="loadingSearchResults" class="p-d-flex p-ai-center p-jc-center" [style]="{height: '50px'}">
                    <p-progressSpinner [style]="{width: '25px', height: '25px'}" styleClass="custom-spinner" animationDuration=".5s"></p-progressSpinner>
                </div>

                <div *ngIf="searchHistory?.length > 0" [hidden]="searchResults?.length > 0 ||
                    moduleSuggestionResults?.length > 0 ||
                    moduleFieldsSuggestionResults?.length > 0 ">
                    <ul class="elastic-search-list">
                        <li *ngFor="let history of searchHistory; index as i">
                            <div class="elastic-search-block">
                                <div [ngStyle]="{'width': '100%', 'margin-top': '4px'}" (click)="goSeachFromHistory(history)">
                                    <p>
                                        <i class="fa fa-clock-o"></i>
                                        <span></span> {{ history?.value }}
                                    </p>
                                </div>
                                <a class="p-mr-0 p-ml-2">
                                    <i class="fa fa-times" (click)="removeHistory(history)"></i>
                                </a>
                            </div>
                        </li>
                    </ul>
                </div>

                <div *ngIf="moduleSuggestionResults?.length > 0">
                    <ul class="elastic-search-list">
                        <li *ngFor="let data of moduleSuggestionResults|globalSearchModuleFilter:moduleSearchValue; index as i" (mouseenter)="searchFocusElement=i" [ngClass]="{'active': i==searchFocusElement}">
                            <div class="elastic-search-block">
                                <div [ngStyle]="{'width': '100%', 'margin-top': '4px'}" (click)="clickModuleSuggestion(data)">
                                    <h6 class="p-mb-0">
                                        <span></span> {{ data?.pluralName }}
                                    </h6>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>

                <!-- <div *ngIf="moduleSuggestionResults?.length > 0">
                    <p-listbox
                            [options]="moduleSuggestionResults"
                            [(ngModel)]="selectedModuleSuggestion"
                            optionLabel="pluralName"
                            (click)="clickModuleSuggestion(selectedModuleSuggestion)">
                    </p-listbox>
                </div> -->

                <div *ngIf="moduleFieldsSuggestionResults?.length > 0">
                    <ul class="elastic-search-list">
                        <li *ngFor="let data of moduleFieldsSuggestionResults|globalSearchFieldFilter:moduleFieldsSearchValue; index as i" (mouseenter)="searchFocusElement=i" [ngClass]="{'active': i==searchFocusElement}">
                            <div class="elastic-search-block">
                                <div [ngStyle]="{'width': '100%', 'margin-top': '4px'}" (click)="clickModuleFieldsSuggestion(data)">
                                    <p>
                                        <span></span> {{ data?.fieldName }}
                                    </p>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>

                <p *ngIf="(searchResults.length == 0 && moduleSuggestionResults?.length == 0 && moduleFieldsSuggestionResults?.length == 0) && !loadingSearchResults && !searchHistoryMsg" class="p-p-4 p-text-center" [hidden]="searchHistory.length>0">
                    No results found!
                </p>
            </div>
        </div>
    </div>
</div>
